import {formatMoney} from "@shopify/theme-currency";

const BASE_URL_IMAGE = ABV4_SETTINGS.base_url_image,
    IMAGE_VERSION = ABV4_SETTINGS.images_version,
    CHECKOUT_POPUP_ENABLE = ABV4_SETTINGS.upsell.checkout_popup,
    HEADING_SINGLE_PRODUCT = ABV4_SETTINGS.upsell.heading_single_product,
    HEADING_POPUP = ABV4_SETTINGS.upsell.heading_popup,
    HEADING_CART = ABV4_SETTINGS.upsell.heading_cart,
    UPSELL_BUNDLE_LIMIT = upsell_limit_bundles;

/**
 * ** MODES **
 * "select_section" mode takes html select value and base on that make upsell offer.
 * "cart" mode takes cart object and makes upsell offer base on added products.
 * ** TYPES **
 * product
 * cart
 * checkout
 * popup
 *
 * Types serve for how to show upsell offer and where
 * */
export class Upsell {
    constructor(popup = null, cart, api, appendTarget, mode, type, removeCartProduct, addedFrom) {

        if (!ABV4_SETTINGS.upsell.enable_upsell) {
            return false;
        }
        this.cart = cart;
        this.api = api;
        this.mode = mode;
        this.addedFrom = addedFrom;
        this.removeCartProduct = removeCartProduct;
        this.type = type;
        this.popup = popup;
        this.appendTarget = appendTarget;
        this.upsellArray = bundles_array;
        this.redirectionPath = 'cart';
        this.checkoutPopupShow = false;
        this.selectedProductVariant = null;
        this.bundlesData = null;
        this.skip_to_cart = false;
        this.bundleContainer = '';
        this.CTA_text = ABV4_SETTINGS.upsell.cta_text;
        this.addBundle = this.addBundle.bind(this);
        this.removeCartData = this.removeCartData.bind(this);
        this.addToCartViaPopup = this.addToCartViaPopup.bind(this);
        this.handleUpsell = this.handleUpsell.bind(this);
        this.prepareDataForCart = this.prepareDataForCart.bind(this);
        this.getTypeMethod = this.getTypeMethod.bind(this)

        this.upSell();
        if(popup !== null) {
            const atc = popup.container.find('.add-bundle-to-cart');
            atc.unbind('click');
            atc.on("click", this.addToCartViaPopup);
        }

        $('.upsell-controls-wrapper').on('click', '.upsell-control', this.handleUpsellControl);
    }

    handleUpsellControl(e) {
        $('.upsell-controls-wrapper').find('.upsell-control').removeClass('active');
        const currentSlide = $(e.currentTarget).data('slide');
        $(e.currentTarget).addClass('active');
        if(currentSlide == 1) {
            $('.upsell-slider').css('transform', 'translateX(0vw)')
        } else if(currentSlide == 2){
            $('.upsell-slider').css('transform', 'translateX(calc(-80vw + 16px))');

         }
    }

    getBundlePrice(bundle) {
        let discountGeneral = bundle.bundle_discount;
        // if(this.getCookie('localization') != 'US') {
        //     discountGeneral = 0;
        // }
        let discountedPrice = 0;
        let originalPrice = 0;
        let discountedAmount = 1 - (discountGeneral * 0.01);
        for (let i = 0; i < bundle.bundle_components.length; i++) {
            const product = bundle.bundle_components[i];
            const qty = product.qty ? product.qty : 1;
            const price = available_bundle_variants[product.id] * qty;
            if(product.hasOwnProperty('discount')) {
                discountedAmount = 1 - (product.discount * 0.01)
            } else {
                discountedAmount = 1 - (discountGeneral * 0.01);
            }
            const discountMath = price * discountedAmount;
            discountedPrice += discountMath;
            originalPrice += price;
        }
    
        return [formatMoney(discountedPrice, window.moneyFormat), formatMoney(originalPrice, window.moneyFormat)];
    }

    addToCartViaPopup(e) {
        this.api.cart()
        .then(this.handleUpsell).then(() => {
            const bundlesData = this.bundlesData;
            for (const bundleData of bundlesData) {
                let success = true;
                // const bundleData = bundleDatas[]
                // if(this.getCookie('localization') != 'US') {
                //     bundleData.bundles[bundleData.bundle_class].bundle_discount = 0;
                // }
                const currentBundle = $(e.currentTarget).data('bundle');
                if(currentBundle == bundleData.bundle_class){
                    const updates = bundleData.updates;
                    this.popup.handleFormSubmitting();
                    const removed = this.removeCartData({updates});
                    removed.then(() => {
                        this.api.addToCart(bundleData.data).catch(() => {
                            console.log(error);
                            this.popup.handleFormSubmitFailed();
                        }).then(() => {
                            if (!success) {
                                let returnDataToCart = {
                                    data: {
                                        items: []
                                    }
                                };
                                Object.keys(updates).map((item) => {
                                    const lineItemId = item.substring(0, item.indexOf(":"));
                                    returnDataToCart.data.items.push({
                                        id: lineItemId,
                                        quantity: 1
                                    });
                                });
            
                                this.api.addToCart(returnDataToCart.data).then(() => {
                                    console.log('Product is sold out!');
                                    window.location.reload();
                                });
            
                            } else {
                                if(this.skip_to_cart){
                                    window.location.href = '/cart'
                                }
                                const klBundle = bundleData.bundles[bundleData.bundle_class];
        
                                const item = {
                                    BundleName: klBundle.bundle_name,
                                    BundleClass: klBundle.bundle_class
                                };
                        
                                _learnq.push(['track', 'Added to Cart', item]);
                                this.popup.handleBundleSubmitted(bundleData.bundles[bundleData.bundle_class], null, false);
                            }
                        });
                    });
                }
            }
        });
    }

    upSell() {
        this.api.cart()
            .then(this.handleUpsell)
            .then(this.addBundle);
    }

    getBundleVariants(bundle) {
        let bundlesVariants = [];
        bundle.bundle_components.forEach((bundleItem) => {
            bundlesVariants.push(bundleItem.id)
        });

        return bundlesVariants;
    }

    validateBundle(cartItems, bundleVariantsIds) {
        let validBundle = false;
        cartItems.forEach((item) => {
            if (bundleVariantsIds.indexOf(item.variant_id) !== -1 && !item.properties.hasOwnProperty('_bundle')) {
                validBundle = true;
            }
        });

        return validBundle;
    }

    updateCartItems(cartItems, bundleVariantsIds) {
        const { removeCartProduct } = this;
        let updateLineItems = [];
        if (removeCartProduct) {
            cartItems.forEach((item) => {
                if (bundleVariantsIds.indexOf(item.variant_id) !== -1 ) {
                    if(item.properties.hasOwnProperty('_single_product') && item.properties._single_product == true || !item.properties.hasOwnProperty('_single_product'))
                        updateLineItems.push({id: item.variant_id, qty: item.quantity, key: item.key});
                }
            });
        }

        return updateLineItems;
    }

    /*
       return bundles based on cart items or current product.
     */
    getTypeMethod(cartItems = []) {
        const {mode, type, addedFrom} = this;
        let activeBundles = [];
        if (type === 'popup') {
            if (addedFrom)
                this.selectedProductVariant = $('.v4-add-to-cart-popup .variant-select option[selected="selected"]').val();
            else
                this.selectedProductVariant = $('.variant-select').val();
        } else if (type === 'product') {
            this.selectedProductVariant = $('.variant-select').val();
        }

        activeBundles = this.specificUpsell();
        
        return activeBundles;
    }

    handleUpsell(data = []) {
        const cartItems = data.items,
            {type, removeCartProduct } = this,
            activeBundles = this.getTypeMethod(cartItems);
            let bundlesHtml = '';

        let bundlesData = [];

        activeBundles.forEach((bundle) => {
            const bundleVariantsIds = this.getBundleVariants(bundle);
            if (removeCartProduct) {
                const validBundle = this.validateBundle(cartItems, bundleVariantsIds);
            }
    

            const updateLineItems = this.updateCartItems(cartItems, bundleVariantsIds);
            const bundleData = this.prepareDataForCart(bundle);
            bundleData.bundles[bundle.bundle_class] = bundle;
            if (updateLineItems.length > 0) {
                updateLineItems.forEach((item) => {
                    const qty = this.removeBundleQtyFromCart(bundle, item);
                    bundleData.updates[item.key] = qty;
                });
            }

            bundlesData.push(bundleData);
        });

        this.bundlesData = bundlesData;

        return bundlesData;
    }

    bundleContainVariant(bundle, variantId) {
        const bundleComponents = bundle.bundle_components;
        let validBundle = false;
        for (const component of bundleComponents) {
            if (component.id === variantId) {
                validBundle = true;
            }
        }
        return validBundle;
    }

    sortBy(arr, prop) {
        return arr.sort((a, b) => b[prop] - a[prop]);
    }

    removeBundleQtyFromCart(bundle, cartLineItem) {
        let result = 0;
        bundle.bundle_components.forEach((bundleItem) => {
            if (bundleItem.id == cartLineItem.id) {
                if (bundleItem.hasOwnProperty('qty')) {
                    result = parseInt(cartLineItem.qty) - parseInt(bundleItem.qty);
                    return result;
                } else {
                    result = parseInt(cartLineItem.qty) - 1;
                    return result;
                }
            }
        });

        if (result < 0) {
            result = 0;
        }
        return result;
    }

    addBundle(bundlesData) {
        let success = true,
            buttons = [];
        const {type, popup} = this;
            buttons = $('.btn-buynow-upsell-bundle');
            let bundleCount = 0;
            for (let i = 0; buttons.length > i; i++) {
                const button = buttons[i];
                const dataUpsellBundle = $(button).attr('data-upsell-bundle');
                const currentBundle = this.getCurrentBundle(bundlesData, dataUpsellBundle);
                const bundleWrapper = $(button).closest('.recommended-product');
                if(bundleCount === 2) {
                    bundleWrapper.remove();
                    break;
                } else if(currentBundle === null) {
                    bundleWrapper.remove();
                }
                if(currentBundle !== null) {
                    bundleCount += 1;
                    const bundle = currentBundle.bundles[dataUpsellBundle];
                    // if(this.getCookie('localization') != 'US'){
                    //     bundle.bundle_discount = 0;
                    // }
                    const bundlePricesObj = this.getBundlePrice(bundle);
                    const orgPrice = parseFloat(bundlePricesObj[1]);
                    const discPrice = parseFloat(bundlePricesObj[0]);
                    bundleWrapper.find('.recommended-product-title').text(bundle.bundle_name);
                    bundleWrapper.find('.recommended-product-price .discounted-price').text(bundlePricesObj[0]);
                    
                    if(orgPrice > discPrice)
                        bundleWrapper.find('.recommended-product-price .original-price').text(bundlePricesObj[1]);
                   
                    $(button).on('click', (e) => {
                        const descriptionClone = $(button).find('.bundle_popup_description_clone').clone().html();
                        e.preventDefault();
                        popup.container.find('.bundle-pane').removeClass('d-none');
                        popup.container.find('.product-pane').addClass('d-none');
                        popup.container.find('.v4-add-to-cart-popup').attr('data-popup-product-handle', dataUpsellBundle);
                        let bundleLabel = bundle.bundle_discount_label ? bundle.bundle_discount_label : null;
                        this.skip_to_cart = $(button).data('skiptocart') ? true : false;
                        if(bundleLabel === null) {
                            bundleLabel = Math.trunc( bundle.bundle_discount );
                            bundleLabel = `Save ${bundleLabel}%`
                        }
                        const cta_label = bundle.cta_label ? bundle.cta_label : false;
                        popup.setBundleHandle(dataUpsellBundle, currentBundle.bundles[dataUpsellBundle], bundleLabel, this.subscriptionProduct = null, descriptionClone, this.skip_to_cart, cta_label, null);

                    });
                } else {
                    const parrentElement = $(button).closest('.check-bundle-availability');
                    if(Boolean(parrentElement)) {
                        parrentElement.addClass('sold-out');
                    }
                }
            }
            if(bundleCount === 2) {
                const upsellControlWrapper = $('.upsell-controls-wrapper'),
                    upsellControls = upsellControlWrapper.find('.upsell-control');
                    if(upsellControls.length > 2) {
                        upsellControls.last().remove();
                    }
                upsellControlWrapper.removeClass('d-none');
            }

            if(bundleCount == 0){
                $('.product-recommended').addClass('d-none');

            }
            $('.upsell-slider-placeholder').addClass('d-none');
            $('.upsell-slider-wrapper').removeClass('d-none');

    }

    getCurrentBundle(bundlesData, currentBundleClass) {
        for(let i = 0; i < bundlesData.length; i++) {
            const bundle = bundlesData[i];
            if(bundle.bundle_class == currentBundleClass) {
                return bundle;
            }
        }

        return null;
    }
    /**
     * Remove product from cart after adding bundle
     *
     * */
    removeCartData(bundleData) {
        return this.api.cartUpdate(bundleData).then(() => console.log('success'));
    }

    // create valid object for adding products to cart
    prepareDataForCart(bundle) {
        let bundleData = {
            bundle_class: bundle.bundle_class,
            data: {
                items: [],
            },
            updates: {},
            bundles: {}
        }, bundleDiscount = bundle.bundle_discount;

        if (bundle.hasOwnProperty('free_components')) {
            bundle.free_components.free_bundle_componets.forEach((variant) => {
                const qty = this.getQty(variant),
                    freeComponentDiscount = this.getFreeComponentDiscount(variant.price);
                bundleData.data.items.push({
                    id: variant.id,
                    quantity: qty,
                    properties: {
                        "_bundle": bundle.bundle_name,
                        "_bundle_discount": freeComponentDiscount,
                        "_bundle_class": bundle.bundle_class,
                        // "_product_price": variant.price,
                        "_base_product_qty": qty,
                        "_single_product": false,
                        "_free_bundle_component": true
                    }
                });
            });
        }
        
        bundle.bundle_components.forEach((item) => {
            if (item.hasOwnProperty('skip') && item.skip === true) {
                return;
            }
            bundleDiscount = bundle.bundle_discount
            if(item.hasOwnProperty('discount')) {
                bundleDiscount = item.discount;
            }
            // if(this.getCookie('localization') != 'US'){
            //     bundleDiscount = 0;
            // }

            const qty = this.getQty(item);
            bundleData.data.items.push({
                id: item.id,
                quantity: qty,
                properties: {
                    "_bundle": bundle.bundle_name,
                    "_bundle_discount": bundleDiscount,
                    "_bundle_class": bundle.bundle_class,
                    // "_product_price": item.price,
                    "_base_product_qty": qty,
                    "_single_product": false,
                }
            });
        });

        return bundleData;
    }

    // get percetange for free product, price must be 0.01 $
    getFreeComponentDiscount(price) {
        const calculateDiscount = 1 / price;
        const result = 100 - calculateDiscount;
        return result;
    }
    /**
     *
     * @param cartLineItems
     * @returns {*[]}
     *
     * get all active bundles
     */
    getActiveBundles(cartLineItems) {
        let activeBundles = [];
        for (let i = 0; i < this.upsellArray.length; i++) {
            const bundle = this.upsellArray[i];
            let ifBundleExist = 0;
            let activeBundle = false;

            bundle.bundle_components.forEach((productVariant) => {
                if (!productVariant.hasOwnProperty('skip') && productVariant.skip !== true) {
                    if (typeof available_bundle_variants[productVariant.id] == 'undefined') {
                        bundle['sold'] = true;
                    }
                }
            });

            if (bundle.hasOwnProperty('free_components')) {
                bundle.free_components.free_bundle_componets.forEach((productVariant) => {
                    if (typeof available_bundle_variants[productVariant.id] == 'undefined') {
                        bundle['sold'] = true;
                    }
                });
            }

            if (!bundle['sold']) {
                let bundlesVariantsIds = [];
                bundle.bundle_components.forEach((bundleItem) => {
                    bundlesVariantsIds.push(bundleItem.id)
                });

                cartLineItems.forEach((lineItem) => {
                    // here we are getting only bundles which are active in cart.
                    if (bundlesVariantsIds.indexOf(lineItem.variant_id) !== -1) {

                        // check if the line item in cart doesn't contain bundle property.
                        // else check if the cart already has this bundle.
                        if (!lineItem.properties.hasOwnProperty('bundle')) {
                            activeBundle = true;
                        } else {
                            if (lineItem.properties.bundle === bundle.bundle_name) {
                                ifBundleExist++;
                            }
                        }
                    }
                });

                // if cart contains the same number of variants as bundle, we can't allow adding this bundle to cart.
                // this bundle already exist in cart.
                if (bundle.bundle_components.length <= ifBundleExist) {
                    activeBundle = false;
                }

                if (activeBundle) {
                    if (activeBundles.length >= upsell_limit_bundles) {
                        break;
                    }
                    activeBundles.push(bundle);
                }
            }
        }
        activeBundles = this.sortBy(activeBundles, 'bundle_original_price');

        return activeBundles;
    }

    /**
     *
     * @return array
     * 
     * */
    specificUpsell() {
        const { selectedProductVariant, type } = this,
            variantId = parseFloat(selectedProductVariant);
        let activeBundles = [],
            preparedBundleName = [];

            for (const bundleUpsell of this.upsellArray) {
                const bundle = this.ifBundleSold(bundleUpsell);

                if (!bundle['sold']) {
                    if (preparedBundleName.indexOf(bundleUpsell.bundle_name) === -1) {
                            activeBundles.push(bundleUpsell);
                    }
                }
            }
        return activeBundles;
    }

    /**
     * @param variant Object
     * @return int
     *
     * */
    getQty(variant) {
        let qty;
        if (variant.hasOwnProperty('qty')) {
            qty = variant.qty;
        } else {
            qty = 1;
        }
        return qty;
    }

    /**
     *
     * @param selector
     * @returns {*[]}
     */
    getProductVariants(selector) {
        const selectSelector = $(selector);
        let variantIds = [];
        selectSelector.each(function () {
            variantIds.push(parseInt($(this).val()));
        });

        return variantIds;

    }

    // check if bundle is sold
    ifBundleSold(bundle) {
        const bundleNumber = bundle.bundle_components.length;
        let soldBundleCounter = 0;
        bundle.bundle_components.forEach((variant) => {
            if (!variant.hasOwnProperty('skip') && variant.skip !== true) {
                if (typeof available_bundle_variants[variant.id] == 'undefined') {
                    if ('replace_variant' in variant) {
                        if (typeof available_bundle_variants[variant.id] == 'undefined') {
                            bundle['sold'] = true;
                        } else {
                            variant.id = variant.replace_variant;
                            variant.price = variant.replace_price;
                        }
                    } else {
                        bundle['sold'] = true;
                    }
                }
            }
        });

        if (bundle.hasOwnProperty('free_components')) {
            bundle.free_components.free_bundle_componets.forEach((product) => {
                if (typeof available_bundle_variants[product.id] == 'undefined') {
                    if ('replace_variant' in product) {
                        if (typeof available_bundle_variants[product.id] == 'undefined') {
                            bundle['sold'] = true;
                        } else {
                            product.id = product.replace_variant;
                            product.price = product.replace_price;
                        }
                    } else {
                        bundle['sold'] = true;
                    }
                }
            });
        }

        return bundle;
    }

    getCookie(name) {
        var pattern = RegExp(name + "=.[^;]*")
        var matched = document.cookie.match(pattern)
        if(matched){
            var cookie = matched[0].split('=')
            return cookie[1]
        }
        return null;
    }
}